@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    display: flex;
    position: relative;
    height: calc(100vh - 145px);

    @include breakpoint.breakpoint(layout.$belowMedium) {
        flex-direction: column-reverse;
        min-height: fit-content;
    }
}

.column1 {
    height: 100%;
    width: 33%;
    overflow: hidden;
    padding-bottom: 10.8rem;

    @include breakpoint.breakpoint(layout.$belowLargeLine) {
        width: 50%;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        width: 100%;
        min-height: fit-content;
    }
}

.column2 {
    min-height: 70vh;
    height: 100%;
    width: 67%;

    @include breakpoint.breakpoint(layout.$belowLargeLine) {
        width: 50%;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        height: 40%;
        width: 100%;
    }
}

.locationError {
    text-align: center;
    margin: 1em;
}
